export default {
  de: {
    title: 'Neuen Berichtstatus hinzufügen',
    name: 'Name',
    submit: 'Berichtstatus erstellen',
    back: 'Zurück',
    alerts: {
      500: () => 'Ein unbekannter Fehler ist aufgetretten! Bitte versuchen Sie es in kürze erneut!',
    },
  },
};
